import $http from '$http';
import { util } from 'utils';
import { lg } from 'utils';
import * as agentApi from '@api/agentApi.js';

export default {
    methods: {
        getAgentDepartmentList() {
            var Params = {
                Sid: this.sysSid,
                Session: this.sysSession
            };
            $http.get('api/Agent/GetAgentDepartmentList', Params).then(res => {
                let { Data } = res.data;
                util.doResult(this, res, () => {
                    this.departmentList = Data;
                });
            });
        }
    }
};


// WEBPACK FOOTER //
// ./src/common/components/agent-info/services.js